import { GeneTypeahead } from '../../../../../src/components/common/Genomics/GeneTypeahead';
import { BaseFilterComponent } from './types';
import { TextEntryFilterOption } from '../options/types';
import { Filter } from '../../types';
import * as React from 'react';

// A gene pair is one that matches the format of {gene1}-{gene2} (ex: "BRCA1-BRCA1")
const singleOrPairRegex = new RegExp(/(\b)-(\b)/gm);

interface GeneCSVEntryProps
  extends TextEntryFilterOption,
    BaseFilterComponent {}

export const GeneCSVEntry: React.FC<GeneCSVEntryProps> = ({
  injectedProps: { textEntryOption },
  onFilterAdd,
  origin,
  selectedFilterOptions,
}) => {
  const handleKeyPress = ({
    // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
    gene: geneOrGenes,
  }) => {
    const splitValues = geneOrGenes
      .split(',')
      .map((_: string) => _.trim())
      .filter(Boolean);

    if (onFilterAdd) {
      const results: Array<Filter> = splitValues.reduce(
        (acc: any, value: any) => {
          const option: Filter = {
            // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
            id: `${textEntryOption.id}+${value.toLowerCase()}`,
            // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
            origin,
            searchKey: singleOrPairRegex.test(value) ? 'genesPair' : 'gene',
            searchValue: value,
          };

          acc.push(option);
          return acc;
        },
        [],
      );

      onFilterAdd(results);
    }
  };

  return (
    <GeneTypeahead
      onGeneAdd={handleKeyPress}
      selections={selectedFilterOptions}
      filterBy="searchValue"
      allowManualEntry
    />
  );
};
